export type LanguageLabelsType = {
    [key: string]: string;
};

export const languageLabels: LanguageLabelsType = {
    en: 'English',
    ja: '日本語'
};
